import {
  updateUserAces as updateUserAcesService,
} from "services/UserService"
import {ACES, UserDtoSummaryWithAces} from "components/admin/user/UserManager.types"

export const updateUserAces = async(
  {userId, aces}: { userId: any, aces: Pick<ACES, "target" | "roles">[] },
  userWithAces: UserDtoSummaryWithAces,
  environmentId: number): Promise<UserDtoSummaryWithAces | undefined> => {
  return updateUserAcesService(userId, aces, environmentId)
    .then(updatedAces => {
      if (userWithAces) {
        return {
          ...userWithAces,
          aces: [
            ...userWithAces.aces.filter(a =>
              !updatedAces.find(newA =>
                newA.target === a.target
              ) && !aces.find(newA =>
                  newA.target === a.target
                )
            ), ...updatedAces]
        }
      }
      return undefined
    })
}